/** @format */

import React from "react";
import { Checkbox,Row } from "antd";

export default ({
  disabled,
  label,
  value,
  handleChange,
  filterType,
  filterId,
}) => (
  <>
  {filterType!=="f_color"?<Checkbox
    disabled={disabled || false}
    label={label}
    filterId={filterId}
    filterType={filterType}
    checked={value}
    onChange={handleChange}
  >
    {label === "True"
      ? "Yes"
      : label === "False"
      ? "No"
      : label === "Express custom" && filterType === "f_product_types"
      ? "Ready to make"
      : label}{" "}
  </Checkbox>:<Row className="filter-label-div ">
    <div style={{background:`${label==='Copper'?'#B87333':label}`}} className="color-div-dek"></div>
    <Checkbox
    disabled={disabled || false}
    label={label}
    filterId={filterId}
    filterType={filterType}
    checked={value}
    onChange={handleChange}
  >
    {label === "True"
      ? "Yes"
      : label === "False"
      ? "No"
      : label === "Express custom" && filterType === "f_product_types"
      ? "Ready to make"
      : label}{" "}
  </Checkbox>
  <div  style={{background:`${label==='Copper'?'#B87333':label}`}} className="color-div-mob"></div>
  </Row>}
  </>
);
